import './styles/index.scss'
import {createRoot} from 'react-dom/client'
import Seccion1 from './components/App'

const origen= document.getElementById('app')
const destino= createRoot(origen)
destino.render(<Seccion1 />)